<div class="info-page">
  <h3>{{ actionLabel }} PROAS</h3>
</div>

<form [formGroup]="form" (ngSubmit)="salvar()">
  <div formArrayName="proas">
    <div *ngFor="let proa of proas().controls; let proaIndex=index">
      <div [formGroupName]="proaIndex" class="form-group">
        <div class="form-group row m-b">
          <div class="col-sm-2">
            <label class="col-sm-12 pb-1">Nº PROA</label>
            <input type="text" id="proa_id" class="form-control" formControlName="proa_id"
              (keyup)="maskProa($event, proaIndex)" required maxlength="17">
            <div *ngIf="proa.get('proa_id').invalid" class="error">
              <label class="error">
                Digite o Número do Processo PROA.
              </label>
            </div>
          </div>
          <div class="col-sm-10 row d-flex">
            <label class="col-sm-12 pb-1">Descrição</label>
            <div class="col-sm-9">
              <textarea id="proa_description" class="form-control" rows="3" formControlName="proa_description"
                maxlength="255"></textarea>
            </div>
            <div class="col-sm-3 pb-1">
              <button class="btn btn-danger" tooltip="Desvincular PROA" type="button"
                (click)="removeProa(proaIndex)">Desvincular PROA</button>
            </div>
          </div>
        </div>

        <div formArrayName="links">
          <div *ngFor="let link of links(proaIndex).controls; let linkIndex=index">
            <div [formGroupName]="linkIndex">
              <div class="form-group row m-b">
                <div class="col-sm-2">
                  <label class="col-sm-12 pb-1">Tipo de Vínculo</label>
                  <ng-select id="type_link" [items]="tipoLinks" bindLabel="label" bindValue="id"
                    placeholder="Seleciona o tipo de Vínculo" formControlName="type_link"
                    (change)="changeTipoVinculo(proaIndex,linkIndex)" required></ng-select>
                  <div *ngIf="!link.get('type_link').value" class="error">
                    <label class="error">Selecione o Tipo de Vínculo</label>
                  </div>
                </div>
                <div class="col-sm-10 row d-flex">
                  <label class="col-sm-12 pb-1">Vínculo</label>
                  <div class="col-sm-8 pb-1">
                    <ng-select id="child_id" [items]="getComboLink(proaIndex,linkIndex)" bindLabel="label" bindValue="id"
                    placeholder="Nenhum" formControlName="child_id" required></ng-select>
                    <div *ngIf="!link.get('child_id').value" class="error">
                      <label class="error">Selecione o Vínculo</label>
                    </div>
                  </div>
                  <div class="col-sm-4 pb-1">
                    <button class="btn btn-danger" tooltip="Excluir vínculo do PROA" type="button"
                      (click)="removeLink(proaIndex, linkIndex)"><i class="fa fas fa-times"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-success btn-add-item" type="button" tooltip="Adicionar vínculo ao PROA"
          (click)="addLink(proaIndex)">Adicionar
          Vínculo</button>
        <div class="hr-line-dashed"></div>
      </div>
    </div>
    <div class="col-sm d-flex justify-content-end">
      <button class="btn btn-success btn-add-item" type="button" tooltip="Adicionar um PROA ao Projeto"
        (click)="addProa()">Adicionar PROA</button>
    </div>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-primary" type="submit">Salvar</button>
    </div>
  </div>
</form>
<!-- {{this.form.value | json}} -->
<app-loading [loader]="isLoading"></app-loading>
<br>
<app-historico-atualizacoes-proa-list [audit]="audit"></app-historico-atualizacoes-proa-list>
